module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "video-player"
  }, [_vm._c('video', {
    ref: _vm.reference,
    attrs: {
      "width": "100%",
      "controls": "",
      "id": _vm.reference
    }
  }, [_vm._c('source', {
    attrs: {
      "src": _vm.src,
      "type": "video/mp4"
    }
  }), _vm._v("\n    Your browser does not support the video tag.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86668ac0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/media/VideoPlayer.vue
// module id = 694
// module chunks = 1